import React, { useState } from "react"
import styled, { css } from "styled-components"
import { Container } from "reactstrap"
import { media } from "utils/Media"
import { Link } from "gatsby"
import Nav from "./Nav"
import HeaderCountdown from "./HeaderCountdown"
import NavMobile from "./NavMobile"
import Logo from "components/shared/Logo"
// import burgerMenu from "images/burger-menu.svg"

const NavBarWrap = styled.div`
	background-color: ${props => props.theme.colors.white};
	height: 100px;
	/* display: flex; */
	/* align-items: center; */
	position: relative;

	&:after {
		content: "";
		position: absolute;
		top: 100%;
		height: 25px;
		width: 100%;
		background-image: linear-gradient(to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, 0));
	}
`

const ContainerStyled = styled(Container)`
	height: 100%;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.nav-toggle-wrap {
		display: flex;
		align-items: center;
	}
`

const NavBarToggle = styled.button`
	/* position: absolute; */
	/* top: 50%; */
	/* transform: translateY(-50%); */
	background-color: transparent;
	border: 0;
	width: 35px;
	height: 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	padding: 0;
	margin-left: .5rem;
	position: relative;

	@media ${media.nav} {
		display: none;
	}

	span {
		display: block;
		/* margin: 5px 0; */
		height: 4px;
		width: 35px;
		border-radius: 3px;
		background-color: ${props => props.theme.colors.primary};
		transition: all .4s ease;
		position: absolute;
		transform-origin: center;
		transform: translateX(-50%);
		left: 50%;

		&:nth-child(1) {
			top: 0;
		}

		&:nth-child(2) {
			top: 50%;
			transform: translate(-50%, -50%);
		}

		&:nth-child(3) {
			bottom: 0;
		}

		${props => props.active && css`
			&:nth-child(1) {
				transform: translate(-50%, -50%) rotate(45deg);
				top: 50%;
				left: 50%;
			}
			&:nth-child(2) {
				opacity: 0;
			}
			&:nth-child(3) {
				transform: translate(-50%, -50%) rotate(-45deg);
				position: absolute;
				top: 50%;
				left: 50%;
			}
		`}
	}


`

const LogoWrap = styled(Link)`
	/* position: absolute; */
	/* top: 50%; */
	left: 0;
	/* transform: translateY(-50%); */

	@media ${media.sm} {
		left: 2rem;
		width: auto;
		text-align: left;
	}
`

export default function NavBar({path}) {
	const [navActive, setNavActive] = useState(false)

	const toggleNav = (e) => {
		e.preventDefault()

		setNavActive(!navActive)
	}

	return (
		<>
			<HeaderCountdown />
			<NavBarWrap>
				<ContainerStyled fluid>
					<LogoWrap to="/">
						<Logo />
					</LogoWrap>
					
					<div className="nav-toggle-wrap">
						<Nav currentPath={path} />
						
						<NavBarToggle onClick={toggleNav} active={navActive}>
							<span></span>
							<span></span>
							<span></span>
						</NavBarToggle>
					</div>
				</ContainerStyled>
			</NavBarWrap>
			<NavMobile navActive={navActive} toggleNav={toggleNav} currentPath={path} />
		</>
	)
}